import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import HatCard from "../components/HatCard";

// Sample hats data with 10 different hats
const hats = [
  {
    id: 1,
    name: "PERFECT GAME",
    price: 15,
    image: "/baseball-cap.jpg",
    description:
      "COD SPAN (97% POLY/3% SPAN) 6 PANEL / CURVED VISOR STRETCH FIT S/M (56CM) & L/XL(58CM)",
  },
  {
    id: 2,
    name: "Fedora",
    price: 20,
    image: "/baseball-cap.jpg",
    description:
      "A stylish hat with a pinched crown and wide brim, adding a touch of elegance to any outfit.",
  },
  {
    id: 3,
    name: "Beanie",
    price: 10,
    image: "/baseball-cap.jpg",
    description:
      "A soft, warm hat ideal for colder weather, keeping your head cozy and comfortable.",
  },
  {
    id: 4,
    name: "Trucker Hat",
    price: 18,
    image: "/baseball-cap.jpg",
    description:
      "A breathable hat with a mesh back, designed for both style and functionality.",
  },
  {
    id: 5,
    name: "Bucket Hat",
    price: 12,
    image: "/baseball-cap.jpg",
    description:
      "A casual hat with a downward-sloping brim, offering great sun protection and a laid-back look.",
  },
  {
    id: 6,
    name: "Panama Hat",
    price: 25,
    image: "/baseball-cap.jpg",
    description:
      "A lightweight, woven hat, perfect for warm climates and beach vacations.",
  },
  {
    id: 7,
    name: "Visor",
    price: 8,
    image: "/baseball-cap.jpg",
    description:
      "A sun-blocking headpiece with an open top, great for sports and outdoor activities.",
  },
  {
    id: 8,
    name: "Snapback",
    price: 22,
    image: "/baseball-cap.jpg",
    description:
      "A structured cap with an adjustable snap closure, a favorite among streetwear enthusiasts.",
  },
  {
    id: 9,
    name: "Bowler Hat",
    price: 30,
    image: "/baseball-cap.jpg",
    description:
      "A round, hard-felt hat with a short brim, exuding a classic and vintage charm.",
  },
];

const MainPage = () => {
  return (
    <Box sx={{ padding: "30px 50px", textAlign: "center" }}>
      <Typography
        variant="h6"
        fontWeight="bold"
        textAlign="left"
        sx={{
          marginBottom: "40px",
          paddingBottom: "30px",
          borderBottom: "1px solid #ccc",
        }}
      >
        Corporate Collection
      </Typography>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{ marginTop: "20px" }}
      >
        {hats.map((hat) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={hat.id}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Link to={`/hat/${hat.id}`} style={{ textDecoration: "none" }}>
              <HatCard hat={hat} />
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MainPage;
